import React, { useState } from 'react';
import DashboardLayout from 'src/layouts/dashboard/DashboardLayout';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import CalculatedBreakdownsExportTable from './components/CalculatedBreakdownsExportTable';
import InvoiceLineItemsExportTable from './components/InvoiceLineItemsExportTable';
import ProductGroupsExportTable from './components/ProductGroupsExportTable';
import SupplierPaymentsExportTable from './components/SupplierPaymentsExportTable';
import PaymentAllocationsExportTable from './components/PaymentAllocationsExportTable';
import SalesMarginsExportTable from './components/SalesMarginsExportTable';

type ExportTab =
  | 'calculated-breakdowns'
  | 'invoice-line-items'
  | 'product-groups'
  | 'supplier-payments'
  | 'payment-allocations'
  | 'sales-margins';

const RebateDataExportPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<ExportTab>(
    'calculated-breakdowns',
  );

  return (
    <DashboardLayout>
      <div className="w-full py-3">
        <Card>
          <CardContent className="pt-6">
            <Tabs
              value={selectedTab}
              onValueChange={(v) => setSelectedTab(v as ExportTab)}
            >
              <TabsList>
                <TabsTrigger value="calculated-breakdowns">
                  Rebate Earnings
                </TabsTrigger>
                <TabsTrigger value="invoice-line-items">
                  Vendor Transactions
                </TabsTrigger>
                <TabsTrigger value="product-groups">Product Groups</TabsTrigger>
                <TabsTrigger value="supplier-payments">
                  Supplier Payments
                </TabsTrigger>
                <TabsTrigger value="payment-allocations">
                  Payment Allocations
                </TabsTrigger>
                <TabsTrigger value="sales-margins">Sales Margins</TabsTrigger>
              </TabsList>

              <TabsContent value="calculated-breakdowns" className="mt-4">
                <CalculatedBreakdownsExportTable />
              </TabsContent>

              <TabsContent value="invoice-line-items" className="mt-4">
                <InvoiceLineItemsExportTable />
              </TabsContent>

              <TabsContent value="product-groups" className="mt-4">
                <ProductGroupsExportTable />
              </TabsContent>

              <TabsContent value="supplier-payments" className="mt-4">
                <SupplierPaymentsExportTable />
              </TabsContent>

              <TabsContent value="payment-allocations" className="mt-4">
                <PaymentAllocationsExportTable />
              </TabsContent>

              <TabsContent value="sales-margins" className="mt-4">
                <SalesMarginsExportTable />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default RebateDataExportPage;
